import { useMemo } from "react";
import { prepareRichHtmlForHost } from "../../utils/richText";

const INLINE_ONLY_TAGS = new Set(["span", "a"]);

export default function RichTextContent({
  content,
  className = "",
  as: Tag = "div",
  inline = false,
}) {
  const { html, tag: RenderTag } = useMemo(
    () => prepareRichHtmlForHost(content, Tag, { inline }),
    [content, Tag, inline]
  );

  if (!html) return null;

  const useInlineClass = inline && INLINE_ONLY_TAGS.has(RenderTag);
  const combinedClassName = [
    className,
    "rich-content",
    useInlineClass ? "rich-content--inline" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <RenderTag
      className={combinedClassName || undefined}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export function CmsText({ content, className = "", as = "span" }) {
  return (
    <RichTextContent
      content={content}
      className={className}
      as={as}
      inline
    />
  );
}
